export const DECK_STATUSES = ['draft', 'published', 'archived'] as const;
export type DeckStatus = (typeof DECK_STATUSES)[number];

export const DECK_STATUS_LABELS: Record<DeckStatus, string> = {
  draft: 'Черновик',
  published: 'Опубликована',
  archived: 'В архиве',
};

/**
 * `kind` separates decks usable as generic material on the free-form table
 * from decks that only serve a specific game sector.
 */
export const DECK_KINDS = ['generic', 'game'] as const;
export type DeckKind = (typeof DECK_KINDS)[number];

/**
 * What the printed card carries.
 *
 * «Таланты» are wordless illustrations — the player reads the picture. Every
 * sector deck prints its situation and questions on the card. On the game
 * screen that is the difference between «покажи мне только образы» and
 * «покажи то, что нужно прочитать», so it is a property of the deck, not a
 * list of slugs somewhere in a component.
 */
export const DECK_CARD_FACES = ['imagery', 'prompt'] as const;
export type DeckCardFace = (typeof DECK_CARD_FACES)[number];

export const DECK_CARD_FACE_LABELS: Record<DeckCardFace, string> = {
  imagery: 'Метафоры',
  prompt: 'С текстом',
};

/**
 * Как колода ведёт себя при вытягивании (§36).
 *
 * Колода у каждого участника своя: карта, доставшаяся одному, остаётся
 * доступной остальным. Так попросила Дарья, и по делу — колоды разного размера,
 * в маленьких карт на всю группу не хватило бы, а совпадение у двоих ничего не
 * ломает: карты в МАК не про соревнование.
 *
 * Поэтому `unique_per_session` читается «у одного человека за сессию не
 * повторяется», а `returns_to_deck` — «может прийти тому же снова».
 */
export const DECK_DRAW_MODES = ['unique_per_session', 'returns_to_deck'] as const;
export type DeckDrawMode = (typeof DECK_DRAW_MODES)[number];


/**
 * Типы изображений, которые принимает загрузка (§18).
 *
 * Список общий для клиента и сервера намеренно: раньше форма предлагала выбрать
 * файл по списку Mantine, куда входит SVG, а сервер его отвергал — человек
 * узнавал об отказе уже после выбора. Проверка на сервере остаётся главной,
 * этот список только не даёт предложить заведомо неподходящее.
 *
 * SVG исключён: он умеет содержать скрипт, а загруженные файлы отдаются с того
 * же origin, что и приложение.
 */
export const UPLOAD_IMAGE_MIME_TYPES = [
  'image/webp',
  'image/jpeg',
  'image/png',
  'image/avif',
  /*
    GIF — ради движущихся картинок в обучении: Дарья показывает ими последовательность
    действий, и разложенная на кадры анимация теряет смысл. Файл сохраняется как есть,
    не пережимается, поэтому движение остаётся. Скрипта GIF не содержит — в отличие от
    SVG, который исключён выше.
  */
  'image/gif',
] as const;
